"use strict";

// https://github.com/typekit/webfontloader

/* This code creates a script element and inserts it right before the very
first script in the document. The code in this script element loads the
Aktive Grotesque font. This font is hosted on the Typekit website.

NOTE: The id currently in use maps to icare's Typekit account. */
window.WebFontConfig = {
  typekit: {
    id: 'ope2hqh'
  }
};
/* eslint-disable no-var */

(function (d) {
  var wf = d.createElement('script'),
      s = d.scripts[0];
  wf.crossOrigin = 'anonymous';
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.async = true;
  s.parentNode.insertBefore(wf, s);
})(document);
/* eslint-enable no-var */
//# sourceMappingURL=typekit.js.map